import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - Miranda Landa Services LLC</title>
        <meta name="description" content="Terms of Service for Miranda Landa Services LLC. Read our terms and conditions for using our business capital consulting services." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Terms of Service
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              1. Acceptance of Terms
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              By accessing or using the services of Miranda Landa Services LLC ("Company," "we," "our," or "us"), 
              you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not 
              use our services.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              2. Description of Services
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Miranda Landa Services LLC provides business capital consulting and advisory services, including:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Business funding consultation and strategy development</li>
              <li>Financial documentation preparation assistance</li>
              <li>Lender matching and introduction services</li>
              <li>Funding feasibility assessment</li>
              <li>Business growth and financing strategy planning</li>
            </ul>
          </div>

          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            marginBottom: '3rem'
          }}>
            <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem'}}>
              ⚠️ Important Disclosure
            </h3>
            <p style={{fontSize: '1rem', color: '#78350f', lineHeight: '1.7'}}>
              <strong>WE ARE NOT A LENDER.</strong> Miranda Landa Services LLC is a consulting firm that provides 
              advisory services only. We do not issue loans, make lending decisions, or guarantee funding approval. 
              All financing is provided by third-party financial institutions. We act solely as a consultant and 
              intermediary to connect businesses with potential lenders.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              3. No Guarantee of Funding
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We do not guarantee that you will receive funding or be approved for any loan or financing product. 
              Approval decisions, loan terms, interest rates, and all other lending conditions are determined solely 
              by the financial institutions we connect you with. Our services are limited to consultation, preparation, 
              and facilitation.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              4. User Responsibilities
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              When using our services, you agree to:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Provide accurate, complete, and truthful information</li>
              <li>Maintain the confidentiality of any account credentials</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Not misrepresent your business or financial situation</li>
              <li>Respond promptly to requests for information or documentation</li>
              <li>Review and understand all terms provided by lenders before accepting any offers</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              5. Fees and Payment
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our consultation fees, if any, will be clearly disclosed before you engage our services. We may receive 
              compensation from financial institutions for successful referrals. Any fees charged by lenders are separate 
              from our consulting fees and are determined by the lender.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              6. Intellectual Property
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              All content on our website, including text, graphics, logos, and software, is the property of Miranda 
              Landa Services LLC and is protected by copyright and other intellectual property laws. You may not 
              reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              7. Limitation of Liability
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              To the fullest extent permitted by law, Miranda Landa Services LLC shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, including loss of profits, revenue, data, or 
              business opportunities, arising from your use of our services or inability to obtain funding.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              8. Disclaimer of Warranties
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our services are provided "as is" and "as available" without warranties of any kind, either express or 
              implied. We do not warrant that our services will be uninterrupted, error-free, or that any information 
              provided will result in funding approval.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              9. Third-Party Relationships
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We work with third-party financial institutions and lenders. We are not responsible for their actions, 
              decisions, terms, or services. Any agreements you enter into with lenders are separate contracts between 
              you and the lender. We encourage you to carefully review all terms before accepting any financing offers.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              10. Privacy and Data Protection
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Your use of our services is also governed by our <Link to="/privacy" style={{color: '#059669', textDecoration: 'underline'}}>Privacy Policy</Link>. 
              By using our services, you consent to the collection, use, and sharing of your information as described 
              in our Privacy Policy.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              11. Communication Consent
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              By providing your contact information, you consent to receive communications from us via phone, email, 
              and SMS text messages regarding our services, your consultation, and related business matters. You may 
              opt out of marketing communications at any time. See our <Link to="/sms-policy" style={{color: '#059669', textDecoration: 'underline'}}>SMS Policy</Link> for 
              more information about text message communications.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              12. Termination
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We reserve the right to terminate or suspend your access to our services at any time, without notice, 
              for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third 
              parties, or for any other reason.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              13. Governing Law
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              These Terms of Service shall be governed by and construed in accordance with the laws of the United States 
              and the state in which Miranda Landa Services LLC is registered, without regard to conflict of law principles.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              14. Changes to Terms
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We reserve the right to modify these Terms of Service at any time. We will notify you of any changes by 
              posting the new Terms of Service on this page and updating the "Last Updated" date. Your continued use 
              of our services after any changes constitutes acceptance of the new terms.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              15. Contact Information
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }}>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                <strong>Miranda Landa Services LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                Legal Inquiries: <a href="mailto:legal@mirandaconnects.com" style={{color: '#059669'}}>legal@mirandaconnects.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46'}}>
                General Contact: <a href="mailto:info@mirandaconnects.com" style={{color: '#059669'}}>info@mirandaconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{
            background: '#f0fdf4',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #10b981',
            textAlign: 'center'
          }}>
            <p style={{fontSize: '1rem', color: '#065f46', lineHeight: '1.7'}}>
              <strong>By using our services, you acknowledge that you have read, understood, and agree to be bound 
              by these Terms of Service.</strong>
            </p>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
            <Link to="/privacy" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #059669'
            }}>
              Privacy Policy
            </Link>
            <Link to="/sms-policy" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #059669'
            }}>
              SMS Policy
            </Link>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
